function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "028---Experiments",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m55 6v3h-4v-3c0-1.1045695-.8954305-2-2-2h-16c-1.1045695 0-2 .8954305-2 2v12h-4v-12c0-3.3137085 2.6862915-6 6-6h16c3.3137085 0 6 2.6862915 6 6z",
  fill: "#f57c00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m52 6v3h-1v-3c0-1.1045695-.8954305-2-2-2h-16c-1.1045695 0-2 .8954305-2 2v12h-4v-12c0-3.3137085 2.6862915-6 6-6h13c3.3137085 0 6 2.6862915 6 6z",
  fill: "#ff9801"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m56 15h-6l-.81-4.84c-.0472953-.29163214.0367876-.58925184.2296936-.81302278.192906-.22377095.4748887-.35078738.7703064-.34697722h5.64c.2954177-.00381016.5774004.12320627.7703064.34697722.192906.22377094.2769889.52139064.2296936.81302278z",
  fill: "#b19046"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m2.5 42c-1.38071183-.0000001-2.49999989-1.1192882-2.49999989-2.5s1.11928806-2.4999999 2.49999989-2.5h40c.893164 0 1.7184816.4764973 2.1650636 1.25s.446582 1.7264973 0 2.5-1.2718996 1.25-2.1650636 1.25z",
  fill: "#7f8e94"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m39 18h-22.2c-.354905.0168048-.6742421.2206642-.8388742.5355233-.1646322.314859-.1498338.6934298.0388742.9944767 4.24 6.77 4 6.36 4 6.76v17.71c0 1.6568542 1.3431458 3 3 3h14c1.6568542 0 3-1.3431458 3-3v-25c0-.5522847-.4477153-1-1-1z",
  fill: "#9d27b0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m11 52h-5v-49.5c0-1.38071187 1.11928813-2.5 2.5-2.5s2.5 1.11928813 2.5 2.5z",
  fill: "#7f8e94"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m12 39.5c-.0017685 1.7267419-1.2660054 3.1926104-2.97375247 3.4480326-1.70774708.2554222-3.34555505-.7763968-3.85247056-2.4270565-.50691551-1.6506596.26947008-3.4238745 1.82622303-4.1709761 1.08268229-.5076522 2.34932676-.4291845 3.3610738.2082161 1.0117471.6374007 1.629388 1.7460328 1.6389262 2.9417839z",
  fill: "#37474f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m7 42.65c-1.22113722-.5734132-2.00084484-1.8009341-2.00084484-3.15s.77970762-2.5765868 2.00084484-3.15c1.22113722.5734132 2.00084484 1.8009341 2.00084484 3.15s-.77970762 2.5765868-2.00084484 3.15z",
  fill: "#607d8b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-path",
  d: "m49 19h8v13h-8z",
  fill: "#0377bc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-path",
  d: "m49 19h5v13h-5z",
  fill: "#02a9f4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#783e22",
  height: 6,
  rx: 1,
  width: 58,
  y: 52
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#a0522d",
  height: 6,
  rx: 1,
  width: 55,
  y: 52
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m37 19v12.63c-2.1227039.2238168-3.9959846 1.486408-5 3.37-2.94 4.91-11 3.09-12 1v-9.71c0-.41.19 0-4-6.76-.188708-.3010469-.2035064-.6796177-.0388742-.9944767.1646321-.3148591.4839692-.5187185.8388742-.5355233h19.2c.5522847 0 1 .4477153 1 1z",
  fill: "#02a9f4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m57 32v12c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4v-12z",
  fill: "#6a1b9a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m54 32v12c-.0032957 1.6269922-.9917334 3.08988-2.5 3.7-1.5082666-.61012-2.4967043-2.0730078-2.5-3.7v-12z",
  fill: "#9d27b0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#00838f",
  height: 4,
  rx: 1,
  width: 10,
  x: 48,
  y: 15
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#00bcd4",
  height: 4,
  rx: 1,
  width: 7,
  x: 48,
  y: 15
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m40 19v13c-.9615606-.3384719-1.9850151-.4646979-3-.37v-12.63c0-.5522847-.4477153-1-1-1h3c.5522847 0 1 .4477153 1 1z",
  fill: "#0377bc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m40 32v12c0 1.6568542-1.3431458 3-3 3h-3c1.6568542 0 3-1.3431458 3-3v-12.37c1.0149849-.0946979 2.0384394.0315281 3 .37z",
  fill: "#6a1b9a"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m58.18 16 .61-3.69c.088214-.5468199-.054292-1.1057365-.3935595-1.5435621-.3392675-.4378257-.844912-.7153492-1.3964405-.7664379v-2c0-3.86599325-3.1340068-7-7-7h-16c-3.8659932 0-7 3.13400675-7 7v11h-9.2c-.7259771.0021742-1.3937691.3975795-1.7447483 1.0330802-.3509791.6355007-.3300246 1.4112922.0547483 2.0269198l3.89 6.23v9.71h-7v-33.5c.015617-.93375479-.3447223-1.83460307-1-2.5-1.0053931-1.01203138-2.52328979-1.31490543-3.84009805-.76623532s-2.17056457 1.83973288-2.15990195 3.26623532v33.5h-2.5c-1.93299662 0-3.5 1.5670034-3.5 3.5s1.56700338 3.5 3.5 3.5h2.5v8h-4c-1.1045695 0-2 .8954305-2 2v4c0 1.1045695.8954305 2 2 2h56c1.1045695 0 2-.8954305 2-2v-4c0-1.1045695-.8954305-2-2-2h-45v-8h7v1c0 2.209139 1.790861 4 4 4h14c2.209139 0 4-1.790861 4-4v-1c1.59 0 2.8.16 4-1 1.0093808-1.0028351 1.3134843-2.5158275.7699678-3.8307867s-1.8271109-2.1717031-3.2499678-2.1692133h-1.52v-17c0-1.1045695-.8954305-2-2-2h-7v-11c0-.55228475.4477153-1 1-1h16c.5522847 0 1 .44771525 1 1v2c-.5515285.0510887-1.057173.3286122-1.3964405.7664379-.3392675.4378256-.4817735.9967422-.3935595 1.5435621l.61 3.69c-1.0337275.093406-1.8242114.9620696-1.82 2v2c.0042869.7102221.3849109 1.3648954 1 1.72v24.28c0 2.7614237 2.2385763 5 5 5s5-2.2385763 5-5v-24.28c.6150891-.3551046.9957131-1.0097779 1-1.72v-2c.0042114-1.0379304-.7862725-1.906594-1.82-2zm-1.18 17h-6v-11h6zm-7-13v-2h8v2zm1.18-8h5.64l-.67 4h-4.3zm-44.18 29.5c0-1.3807119 1.11928813-2.5 2.5-2.5 1.3807119 0 2.5 1.1192881 2.5 2.5s-1.1192881 2.5-2.5 2.5c-1.38071187 0-2.5-1.1192881-2.5-2.5zm2.5-38.5c.8284271 0 1.5.67157288 1.5 1.5v32.78c-.9657259-.3702652-2.03427408-.3702652-3 0v-32.78c0-.82842712.67157288-1.5 1.5-1.5zm-7.5 38.5c0-.8284271.67157288-1.5 1.5-1.5h1.78c-.37026518.9657259-.37026518 2.0342741 0 3h-1.78c-.82842712 0-1.5-.6715729-1.5-1.5zm56 17.5h-56v-4h56zm-50-6v-7.28c.96572592.3702652 2.0342741.3702652 3 0v7.28zm5.72-10c.3702652-.9657259.3702652-2.0342741 0-3h6.28v3zm26.28 3c0 1.1045695-.8954305 2-2 2h-14c-1.1045695 0-2-.8954305-2-2v-5.93c3.68 1.85 9.41 1.52 11.86-2.56 1.1685916-2.2223467 3.7021812-3.3612241 6.14-2.76zm3.5-6c.6062833.0005333 1.1526315.3659901 1.384574.926153.2319424.5601628.1038666 1.2048734-.324574 1.633847-.53.53-1 .44-2.56.44v-3zm-3.5-7.3c-3.1627057-.5605122-6.3291231.9662973-7.86 3.79-1.46 2.43-4.2 2.69-5.73 2.64-1.5909474.0244693-3.1440028-.4861724-4.41-1.45v-.68h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-3v-2h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-3v-2h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-3.45l-3.75-6h22.2zm10-27.7h-16c-1.6568542 0-3 1.34314575-3 3v11h-2v-11c0-2.76142375 2.2385763-5 5-5h16c1.3260824 0 2.597852.5267842 3.5355339 1.46446609.9376819.9376819 1.4644661 2.20945146 1.4644661 3.53553391v2h-2v-2c0-1.65685425-1.3431458-3-3-3zm4 44c-1.6568542 0-3-1.3431458-3-3v-11h6v11c0 1.6568542-1.3431458 3-3 3z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 37,
  cy: 39,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 33,
  cy: 43,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 29,
  cy: 45,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 25,
  cy: 44,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 37,
  cy: 45,
  r: 1
})));

var SvgExperiment = function SvgExperiment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 61",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExperiment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/experiment.f362beb2.svg";
export { ForwardRef as ReactComponent };